import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Loader({ onDone }) {
    const [count, setCount] = useState(0);
    const [gone, setGone] = useState(false);

    useEffect(() => {
        let n = 0;
        const iv = setInterval(() => {
            n += Math.max(1, Math.floor(Math.random() * 8));
            if (n >= 100) {
                n = 100;
                clearInterval(iv);
                setTimeout(() => {
                    setGone(true);
                    onDone?.();
                }, 420);
            }
            setCount(n);
        }, 55);
        return () => clearInterval(iv);
    }, [onDone]);

    return (
        <AnimatePresence>
            {!gone && (
                <motion.div
                    initial={{ y: 0 }}
                    exit={{ y: "-100%" }}
                    transition={{ duration: 1.05, ease: [0.77, 0, 0.18, 1] }}
                    className="fixed inset-0 z-[9998] bg-ink-950 flex items-end justify-between px-6 md:px-10 py-8"
                    data-testid="loader"
                >
                    <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-bone-50">
                        Francesco Ciotoli — Studio
                    </span>
                    <span
                        className="font-display uppercase text-bone-50 leading-none tabular-nums"
                        style={{ fontSize: "clamp(4rem, 18vw, 22rem)" }}
                    >
                        {String(count).padStart(3, "0")}<span className="text-flash">.</span>
                    </span>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
